// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Lottery from '../views/Lottery.vue'
import CreateLottery from '../views/CreateLottery.vue'
import AuthSite from '../views/AuthSite.vue'

const routes = [
    { path: '/', component: Home },
    { path: '/lottery', component: Lottery },
    { path: '/createLottery', component: CreateLottery },
    { path: '/authSite', component: AuthSite }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
